import {
  WORKKEYS_REPLACE_TERMS,
  WORKKEYS_REPLACE_URL_SUBPAGE,
  WORKKEYS_REPLACE_URL_CONTENT_TYPE,
  WORKKEYS_REPLACE_QUERY_CONTENT_TYPE,
  WORKKEYS_REPLACE_QUERY_CONTENT_TYPE_REVERSE,
  WORKKEYS_REPLACE_URL_CONTENT_TYPE_REVERSE
} from "../constants/workkeysReplaceTerms"

export const getWorkkeysReplaceTerm = (
  initialWord: string,
  capitalize: boolean = false
) => {
  if (!initialWord) {
    return ""
  }

  const lowerCaseInitialWord = initialWord.toLowerCase()

  const resultWord = WORKKEYS_REPLACE_TERMS[lowerCaseInitialWord]

  if (!resultWord) {
    return initialWord
  }

  if (capitalize) {
    return resultWord
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
  }

  return resultWord
}

export const getWorkkeysReplaceUrlSubpage = (subpage: string) => {
  return WORKKEYS_REPLACE_URL_SUBPAGE[subpage] || subpage
}

export const getWorkkeysReplaceUrlContentType = (contentType: string) => {
  return WORKKEYS_REPLACE_URL_CONTENT_TYPE[contentType] || contentType
}

export const getWorkkeysReplaceUrlContentTypeReverse = (
  contentType: string
) => {
  return WORKKEYS_REPLACE_URL_CONTENT_TYPE_REVERSE[contentType] || contentType
}

export const getWorkkeysReplaceQueryContentType = (contentType: string) => {
  return WORKKEYS_REPLACE_QUERY_CONTENT_TYPE[contentType] || contentType
}

export const getWorkkeysReplaceQueryContentTypeReverse = (
  contentType: string
) => {
  return WORKKEYS_REPLACE_QUERY_CONTENT_TYPE_REVERSE[contentType] || contentType
}
